import { List, Map } from 'immutable';

import * as type from './actionTypes';

const initialState = Map({
  list: List(),
  listQuals: [],
  pagination: { total: 1, page: 1 },
  paginationQuals: { total: 1, page: 1 },
  waiting: false,
  rate: {},
  selectedSP: { type: 'rate' },
});

export default function (state = initialState, action) {
  switch (action.type) {
    case type.UPDATE_WAITING:
      return state.set('waiting', action.waiting);

    case type.SET_SELECTED_SP:
      return state.set('selectedSP', action.sp);

    case type.UPDATE_RATE:
      return state.set('rate', action.rate);

    case type.SET_QUALS:
      const paginationQuals = {
        total: action.payload.pagination.total,
        page: action.page,
      };
      return state
        .set('listQuals', action.payload.data)
        .set('paginationQuals', paginationQuals);

    case type.SET_RATES:
      if (action.payload && Array.isArray(action.payload)) {
        action.payload.unshift({ name: 'All', id: 0 });
      }
      return state.set('list', List(action.payload));

    case type.ADD_RATE:
      return state.set(
        'list',
        state
          .get('list')
          .concat([action.rate])
          .sort((a, b) => a.name.localeCompare(b.name)),
      );

    case type.REMOVE_SP:
      if (action.sp.type === 'qual') {
        return state.set(
          'listQuals',
          state.get('listQuals').filter((q) => q.id !== action.sp.id),
        );
      }
      return state.set(
        'list',
        state.get('list').filter((r) => r.id !== action.sp.id),
      );

    case type.ADD_QUAL:
      return state.set(
        'listQuals',
        state
          .get('listQuals')
          .concat([action.qual])
          .sort((a, b) => a.name.localeCompare(b.name)),
      );

    case type.UPDATE_SP:
      if (action.sp.isQual) {
        return state.set(
          'listQuals',
          state
            .get('listQuals')
            .map((sp) => {
              if (sp.id === action.sp.id) {
                return action.sp;
              }
              return sp;
            })
            .slice(),
        );
      }
      return state.set(
        'list',
        state.get('list').map((sp) => {
          if (sp.id === action.sp.id) {
            return action.sp;
          }
          return sp;
        }),
      );

    case type.SET_RATING_EXAM_QUESTION_PERCENTAGE:
      const { percentage, questions } = action.percentage;
      return state.set(
        'list',
        state.get('list').map((r) => {
          if (r.id === action.rate) {
            r.percentage = percentage;
            r.questions = questions;
          }
          return r;
        }),
      );

    default:
      return state;
  }
}
